import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import {
  AppliedToplineItem, AppliedToplineItemWithConnectionToplinesFragment,
  EntityConnectionCoreFragment, EntityConnectionTypeDetailsFragment,
  EntityConnectionWithToplinesFragment, GetEntityConnectionTypeGQL
} from 'generated/graphql';

import { connectionTypeName, getSafe, isNilOrEmpty } from 'helpers';
import { ToplineAddClickedEvent } from '../ToplineAddClickedEvent';

@Component({
  selector: 'app-topline-connection',
  templateUrl: './topline-connection.component.html',
})
export class ToplineConnectionComponent implements OnInit {
  @Input() topline: Partial<AppliedToplineItemWithConnectionToplinesFragment> | any;
  @Input() targetType: 'Entity' | 'EntityConnection';
  @Input() targetId: string;
  /** For connections, the parent displaying the conneciton */
  @Input() parentEntityId: string;

  /** used for top topline */
  @Input() truncate: boolean;
  @Output() addClick = new EventEmitter<ToplineAddClickedEvent>();

  entityConnectionType: EntityConnectionTypeDetailsFragment;

  /** start Used for truncation */
  get firstConnection(): EntityConnectionCoreFragment & EntityConnectionWithToplinesFragment {
    return getSafe(() => this.topline.appliedToplineValue.entityConnections[0], null);
  }

  get connectedEntityTypeName() {
    if (isNilOrEmpty(this.entityConnectionType)) {
      return '';
    }

    const otherEntity = this.getConnectedToEntity(this.firstConnection);

    const et = [
      this.entityConnectionType?.entityType1,
      this.entityConnectionType?.entityType2,
    ].find(t => t.id === otherEntity.entityTypeId);

    return et?.nameSingular;
  }

  /** </end used for truncation> */


  get connectionName() {
    if (isNilOrEmpty(this.entityConnectionType)) {
      return '';
    }

    return connectionTypeName(this.entityConnectionType);
  }

  get connections() {
    return this.topline?.appliedToplineValue?.entityConnections;
  }

  constructor(private _getEntityConnectionTypeGQL: GetEntityConnectionTypeGQL) { }

  ngOnInit(): void {
    this._getEntityConnectionTypeGQL.fetch({ id: this.topline.toplineItem.itemId })
      .subscribe(({ data }) => {
        this.entityConnectionType = data.getEntityConnectionType;
      });
  }

  onAddClicked() {
    const eventData = { targetType: this.targetType, targetId: this.targetId, topline: this.topline };
    this.addClick.emit(eventData);
  }

  passThroughClick(event: ToplineAddClickedEvent) {
    this.addClick.emit(event);
  }

  getConnectedToEntity(connection: EntityConnectionCoreFragment) {
    return [
      connection.entity1,
      connection.entity2
    ].find((et) => this.parentEntityId !== et.id);
  }
}
